import { helper } from '@ember/component/helper';
import moment from 'moment-timezone';

const FORMAT_TIME = 'HH:mm';
const FORMAT_DATE = 'D MMM';
const FORMAT_FULL = 'DD/MM/YYYY';
const FORMAT_DEFAULT = 'D MMM YYYY HH:mm';

/**
 * Converte timestamp Unix in testo ottimizzato per visualizzazione
 */
var timeTickstotext = helper(function timeTickstotext([timeTicks, formatDate]) {
  if (!timeTicks) return '';
  const date = moment.unix(timeTicks);
  if (formatDate === 'optimize') {
    const today = moment();
    if (date.isSame(today, 'day')) return date.format(FORMAT_TIME);
    if (date.isSame(today, 'year')) return date.format(FORMAT_DATE);
    return date.format(FORMAT_FULL);
  }
  return date.format(formatDate || FORMAT_DEFAULT);
});

export { timeTickstotext as default };
//# sourceMappingURL=time-tickstotext.js.map
